module.exports = __webpack_public_path__ + "static/13-0a8074a02552465bd803ca5056a81feb.jpeg";